import React, { useContext } from "react";
import { LanguageContext } from "../context/LanguageContext";
import { GERMAN } from "../actions/language";
import PageHero from "./common/PageHero";
import {
    OFFICE_BUSINESS_CARDS_JORGE_PHONE_NUMBER,
    OFFICE_BUSINESS_CARDS_PAULO_PHONE_NUMBER,
    OFFICE_CONTACT_EMAIL,
    OFFICE_CONTACT_OFFICE_FAX_NUMBER,
    OFFICE_CONTACT_OFFICE_PHONE_NUMBER,
    OFFICE_LOCATION_PLACE,
    OFFICE_LOCATION_STREET
} from "../env";

const MAP_SRC = "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d5136.665143853276!2d8.314823576564901!3d49.93010067149755!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47bd9a61687370d7%3A0x9ab1f3604252bc4c!2sGutenbergstra%C3%9Fe%2021%2C%2055294%20Bodenheim!5e0!3m2!1sde!2sde!4v1736207409816!5m2!1sde!2sde";

const Kontakt = () => {
    const { language } = useContext(LanguageContext);
    const de = language === GERMAN;

    return (
        <div>
            <PageHero
                eyebrow={de ? 'Kontakt' : 'Contacto'}
                title={de
                    ? <span>Wir sind <em>für Sie da</em>.</span>
                    : <span>Estamos <em>aqui para si</em>.</span>}
                lede={de
                    ? 'Ob erste Beratung oder Fragen zu unseren Leistungen – Sie erreichen uns telefonisch, per E-Mail oder direkt bei unseren Geschäftsführern. Wir melden uns zeitnah zurück.'
                    : 'Quer pretenda uma primeira consulta ou tenha dúvidas sobre os nossos serviços – pode contactar-nos por telefone, e-mail ou diretamente junto dos nossos gerentes. Responderemos rapidamente.'}
            />

            {/* Büro & Standort */}
            <section className="tm-section">
                <div className="tm-container">
                    <div className="tm-contact-grid">
                        <div className="tm-contact-card">
                            <span className="tm-contact-card__icon"><i className="fas fa-building"/></span>
                            <h3>{de ? 'Büro' : 'Escritório'}</h3>
                            <p className="tm-contact-card__role">Tomé & Martins GbR</p>
                            <div className="tm-contact-card__rows">
                                <a href={'mailto:' + OFFICE_CONTACT_EMAIL}>
                                    <i className="fas fa-envelope"/>{OFFICE_CONTACT_EMAIL}
                                </a>
                                <a href="tel:+4961357044080">
                                    <i className="fas fa-phone"/>{OFFICE_CONTACT_OFFICE_PHONE_NUMBER}
                                </a>
                                <span>
                                    <i className="fas fa-fax"/>{OFFICE_CONTACT_OFFICE_FAX_NUMBER}
                                </span>
                            </div>
                            <a href={'mailto:' + OFFICE_CONTACT_EMAIL} className="tm-btn tm-btn--primary">
                                {de ? 'E-Mail schreiben' : 'Escrever e-mail'}
                            </a>
                        </div>

                        <div className="tm-contact-card">
                            <span className="tm-contact-card__icon"><i className="fas fa-user-tie"/></span>
                            <h3>Jorge Tomé</h3>
                            <p className="tm-contact-card__role">
                                {de ? 'Geschäftsführer' : 'Gerente'}
                            </p>
                            <div className="tm-contact-card__rows">
                                <a href="tel:+491782589658">
                                    <i className="fas fa-mobile-alt"/>{OFFICE_BUSINESS_CARDS_JORGE_PHONE_NUMBER}
                                </a>
                                <span>
                                    <i className="fas fa-comments"/>{de ? 'Deutsch · Português' : 'Alemão · Português'}
                                </span>
                            </div>
                            <a href="tel:+491782589658" className="tm-btn tm-btn--outline-ink">
                                {de ? 'Direkt anrufen' : 'Ligar diretamente'}
                            </a>
                        </div>

                        <div className="tm-contact-card">
                            <span className="tm-contact-card__icon"><i className="fas fa-user-tie"/></span>
                            <h3>Paulino Martins</h3>
                            <p className="tm-contact-card__role">
                                {de ? 'Geschäftsführer' : 'Gerente'}
                            </p>
                            <div className="tm-contact-card__rows">
                                <a href="tel:+491788570289">
                                    <i className="fas fa-mobile-alt"/>{OFFICE_BUSINESS_CARDS_PAULO_PHONE_NUMBER}
                                </a>
                                <span>
                                    <i className="fas fa-comments"/>{de ? 'Deutsch · Português' : 'Alemão · Português'}
                                </span>
                            </div>
                            <a href="tel:+491788570289" className="tm-btn tm-btn--outline-ink">
                                {de ? 'Direkt anrufen' : 'Ligar diretamente'}
                            </a>
                        </div>
                    </div>
                </div>
            </section>

            {/* Standort & Karte */}
            <section className="tm-section tm-section--tight" style={{ paddingTop: 0 }}>
                <div className="tm-container">
                    <div className="tm-section__head">
                        <span className="tm-eyebrow">{de ? 'Standort' : 'Localização'}</span>
                        <h2 className="tm-section__title">
                            {de
                                ? <span>Sie finden uns in <em>Bodenheim</em>.</span>
                                : <span>Encontra-nos em <em>Bodenheim</em>.</span>}
                        </h2>
                        <p className="tm-section__lede">
                            {OFFICE_LOCATION_STREET}, {OFFICE_LOCATION_PLACE} — {de
                                ? 'wenige Minuten südlich von Mainz, gut erreichbar mit Auto und Bahn.'
                                : 'a poucos minutos a sul de Mainz, de fácil acesso de carro e comboio.'}
                        </p>
                    </div>
                    <div className="tm-map">
                        <iframe
                            title={de ? 'Karte: Gutenbergstraße 21, Bodenheim' : 'Mapa: Gutenbergstraße 21, Bodenheim'}
                            src={MAP_SRC}
                            allowFullScreen=""
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"
                        />
                    </div>
                </div>
            </section>
        </div>
    );
}

export default Kontakt;



// WEBPACK FOOTER //
// ./src/components/Kontakt.js